/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FeaturesIndexRouteImport } from './routes/features/index'
import { Route as FeaturesSubscriptionsRouteImport } from './routes/features/subscriptions'
import { Route as FeaturesPayoutsRouteImport } from './routes/features/payouts'
import { Route as FeaturesInvoicingRouteImport } from './routes/features/invoicing'
import { Route as FeaturesGatewayRouteImport } from './routes/features/gateway'
import { Route as FeaturesAcceptPaymentsRouteImport } from './routes/features/accept-payments'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesIndexRoute = FeaturesIndexRouteImport.update({
  id: '/features/',
  path: '/features/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesSubscriptionsRoute = FeaturesSubscriptionsRouteImport.update({
  id: '/features/subscriptions',
  path: '/features/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesPayoutsRoute = FeaturesPayoutsRouteImport.update({
  id: '/features/payouts',
  path: '/features/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesInvoicingRoute = FeaturesInvoicingRouteImport.update({
  id: '/features/invoicing',
  path: '/features/invoicing',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesGatewayRoute = FeaturesGatewayRouteImport.update({
  id: '/features/gateway',
  path: '/features/gateway',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesAcceptPaymentsRoute = FeaturesAcceptPaymentsRouteImport.update({
  id: '/features/accept-payments',
  path: '/features/accept-payments',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/compliance': typeof ComplianceRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/docs': typeof DocsRoute
  '/legal': typeof LegalRoute
  '/partners': typeof PartnersRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/features/accept-payments': typeof FeaturesAcceptPaymentsRoute
  '/features/gateway': typeof FeaturesGatewayRoute
  '/features/invoicing': typeof FeaturesInvoicingRoute
  '/features/payouts': typeof FeaturesPayoutsRoute
  '/features/subscriptions': typeof FeaturesSubscriptionsRoute
  '/features/': typeof FeaturesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/compliance': typeof ComplianceRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/docs': typeof DocsRoute
  '/legal': typeof LegalRoute
  '/partners': typeof PartnersRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/features/accept-payments': typeof FeaturesAcceptPaymentsRoute
  '/features/gateway': typeof FeaturesGatewayRoute
  '/features/invoicing': typeof FeaturesInvoicingRoute
  '/features/payouts': typeof FeaturesPayoutsRoute
  '/features/subscriptions': typeof FeaturesSubscriptionsRoute
  '/features': typeof FeaturesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/compliance': typeof ComplianceRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/docs': typeof DocsRoute
  '/legal': typeof LegalRoute
  '/partners': typeof PartnersRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/features/accept-payments': typeof FeaturesAcceptPaymentsRoute
  '/features/gateway': typeof FeaturesGatewayRoute
  '/features/invoicing': typeof FeaturesInvoicingRoute
  '/features/payouts': typeof FeaturesPayoutsRoute
  '/features/subscriptions': typeof FeaturesSubscriptionsRoute
  '/features/': typeof FeaturesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blog'
    | '/compliance'
    | '/contact'
    | '/cookies'
    | '/docs'
    | '/legal'
    | '/partners'
    | '/pricing'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/blog/$slug'
    | '/features/accept-payments'
    | '/features/gateway'
    | '/features/invoicing'
    | '/features/payouts'
    | '/features/subscriptions'
    | '/features/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blog'
    | '/compliance'
    | '/contact'
    | '/cookies'
    | '/docs'
    | '/legal'
    | '/partners'
    | '/pricing'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/blog/$slug'
    | '/features/accept-payments'
    | '/features/gateway'
    | '/features/invoicing'
    | '/features/payouts'
    | '/features/subscriptions'
    | '/features'
  id:
    | '__root__'
    | '/'
    | '/blog'
    | '/compliance'
    | '/contact'
    | '/cookies'
    | '/docs'
    | '/legal'
    | '/partners'
    | '/pricing'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/blog/$slug'
    | '/features/accept-payments'
    | '/features/gateway'
    | '/features/invoicing'
    | '/features/payouts'
    | '/features/subscriptions'
    | '/features/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlogRoute: typeof BlogRouteWithChildren
  ComplianceRoute: typeof ComplianceRoute
  ContactRoute: typeof ContactRoute
  CookiesRoute: typeof CookiesRoute
  DocsRoute: typeof DocsRoute
  LegalRoute: typeof LegalRoute
  PartnersRoute: typeof PartnersRoute
  PricingRoute: typeof PricingRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  FeaturesAcceptPaymentsRoute: typeof FeaturesAcceptPaymentsRoute
  FeaturesGatewayRoute: typeof FeaturesGatewayRoute
  FeaturesInvoicingRoute: typeof FeaturesInvoicingRoute
  FeaturesPayoutsRoute: typeof FeaturesPayoutsRoute
  FeaturesSubscriptionsRoute: typeof FeaturesSubscriptionsRoute
  FeaturesIndexRoute: typeof FeaturesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features/': {
      id: '/features/'
      path: '/features'
      fullPath: '/features/'
      preLoaderRoute: typeof FeaturesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features/subscriptions': {
      id: '/features/subscriptions'
      path: '/features/subscriptions'
      fullPath: '/features/subscriptions'
      preLoaderRoute: typeof FeaturesSubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features/payouts': {
      id: '/features/payouts'
      path: '/features/payouts'
      fullPath: '/features/payouts'
      preLoaderRoute: typeof FeaturesPayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features/invoicing': {
      id: '/features/invoicing'
      path: '/features/invoicing'
      fullPath: '/features/invoicing'
      preLoaderRoute: typeof FeaturesInvoicingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features/gateway': {
      id: '/features/gateway'
      path: '/features/gateway'
      fullPath: '/features/gateway'
      preLoaderRoute: typeof FeaturesGatewayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features/accept-payments': {
      id: '/features/accept-payments'
      path: '/features/accept-payments'
      fullPath: '/features/accept-payments'
      preLoaderRoute: typeof FeaturesAcceptPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof BlogRoute
    }
  }
}

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlogRoute: BlogRouteWithChildren,
  ComplianceRoute: ComplianceRoute,
  ContactRoute: ContactRoute,
  CookiesRoute: CookiesRoute,
  DocsRoute: DocsRoute,
  LegalRoute: LegalRoute,
  PartnersRoute: PartnersRoute,
  PricingRoute: PricingRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  FeaturesAcceptPaymentsRoute: FeaturesAcceptPaymentsRoute,
  FeaturesGatewayRoute: FeaturesGatewayRoute,
  FeaturesInvoicingRoute: FeaturesInvoicingRoute,
  FeaturesPayoutsRoute: FeaturesPayoutsRoute,
  FeaturesSubscriptionsRoute: FeaturesSubscriptionsRoute,
  FeaturesIndexRoute: FeaturesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
